<div *ngIf="showLoader" class="loader">
    <mat-spinner strokeWidth="3" diameter="100" color="#000"></mat-spinner>
</div>

<div class="background">
    <div class="backimage">
        <button type="button" (click)="backButtonNavigate()" class="backbtn">
            Back
        </button>
    </div>
    <div class="headertext">
        Test Slip ID {{ offlineTestSlipId }}
    </div>
    <div>
        <input type="button" [ngClass]="statusName == 'Approved' ? 'buttonapprovedclass' : 'buttonreviewclass'"
            value="{{statusName | uppercase}}" />
    </div>

    <!-- // test Slip Status start -->
    <div class="container-fluid p-5">
        <div class="row p-3 ml-2" id="fullData">
            <!-- // left side -->
            <div class="col-lg-6" id="left-sidepanel">
                <div class="p-3" id="testSlipStatustab">
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="headertesttext">
                                Test Slip Status
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>
                        <div class="status">
                            <table #dataTable class="table table-striped">
                                <thead>
                                    <tr>
                                        <th scope="col" class="w-30">
                                            STATUS
                                        </th>
                                        <th scope="col" class="w-30">
                                            UPDATED ON
                                        </th>
                                        <th scope="col">UPDATED BY</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let item of smthAuditTrails; let i = index">
                                        <td>
                                            <div *ngIf="item?.statusName">
                                                <span class="columnStatus">{{ item.statusName | titlecase }}</span>
                                            </div>
                                        </td>
                                        <td>
                                            <span class="columnModify"></span>
                                        </td>
                                        <td>
                                            <span class="columnModify"></span><br />
                                            <span class="emailFont"></span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </mat-expansion-panel>
                </div>
                <div class="p-3" id="testSlipDetailstab" [formGroup]="testslipDetailsForm">
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="headertesttext">
                                Test Slip Details
                            </mat-panel-title>
                            <mat-panel-description> </mat-panel-description>
                        </mat-expansion-panel-header>

                        <div class="option-container slip-label required">Enter one of the following</div>
                        <div class="backgroundWhite slip-details-container">
                            <div class="slip-label">Fault Number</div>
                            <div class="slip-detail-value">
                                <input type="text" class="form-control input-sm txt-input" formControlName="faultNo"
                                    placeholder="Enter fault number">
                            </div>
                            <div class="slip-label">OR</div>
                            <div class=""></div>
                            <div class="slip-label">Work Order Number</div>
                            <div class="slip-detail-value">
                                <input type="text" class="form-control input-sm txt-input" formControlName="workorderNo"
                                    placeholder="Enter work order number">
                            </div>

                            <div class="slip-label required">Site of work</div>
                            <div class="slip-detail-value">
                                <input type="text" class="form-control input-sm txt-input" formControlName="site"
                                    placeholder="Enter site of work">
                            </div>

                            <div class="slip-label required">Equipment</div>
                            <div class="slip-detail-value">
                                <input type="text" class="form-control input-sm txt-input" formControlName="assetId"
                                    placeholder="Enter equipment">
                            </div>

                            <div class="slip-label required">Depot</div>

                            <div class="slip-detail-value">
                                <select formControlName="depotId" name="depot" class="form-control">
                                    <option value="" disabled selected hidden>Select depot</option>
                                    <option *ngFor="let smthOrg of smthOrgStructure" [value]="smthOrg.id">
                                        {{ smthOrg.sectionManager }}
                                    </option>
                                </select>
                            </div>

                            <div class="slip-label required">Details of work</div>
                            <div class="slip-detail-value">
                                <input type="text" formControlName="workDetails" class="form-control input-sm txt-input"
                                    placeholder="Enter details">
                            </div>

                            <div class="slip-label required">SMTH Plan(s) executed</div>
                            <div class="slip-detail-value">
                                <mat-form-field subscriptSizing="dynamic" [floatLabel]="'never'" class="chip-list">
                                    <mat-chip-grid #chipList aria-label="SMTH plan selection">
                                        <mat-chip-row *ngFor="let plan of smthPlans" 
                                            [removable]="removable" (removed)="remove(plan)">
                                            {{plan.testPlan}}
                                            <mat-icon matChipRemove class="close-icon"
                                                *ngIf="removable">close</mat-icon>
                                        </mat-chip-row>
                                        <input class="form-control-chip" [placeholder]="(chipList?._chips?.length === 0 && !smthPlanCtrl.value) ? 'Search SMTH Plan(s)' : ''" #smthPlanInput
                                            #autocompleteTrigger="matAutocompleteTrigger" [formControl]="smthPlanCtrl"
                                            [matAutocomplete]="auto" [matChipInputFor]="chipList"
                                            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                            (matChipInputTokenEnd)="addPlans($event)">
                                    </mat-chip-grid>
                                    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedPlans($event)"
                                        autoActiveFirstOption>
                                        <mat-option *ngFor="let smthPlan of filteredSmthPlans | async"
                                            [value]="smthPlan">
                                            <mat-checkbox color="primary"
                                                [checked]="toggleCheck(smthPlan)"></mat-checkbox>
                                            <span class="checkbox-label">{{smthPlan.testPlan}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                    <button mat-icon-button matSuffix class="icon-btn"
                                        (click)="openAuto(autocompleteTrigger)"> <mat-icon
                                        class="icon">expand_more</mat-icon></button>
                                </mat-form-field>
                            </div>

                            <div class="slip-label required">Name(s) of person(s) doing the work</div>
                            <div class="slip-detail-value">
                                <input type="text" formControlName="workers" class="form-control input-sm txt-input"
                                    placeholder="Enter name">
                            </div>

                            <div class="slip-label required">Name of person Doing the testing</div>
                            <div class="slip-detail-value">
                                <div class="nr-search-box">
                                    <input matInput type="search" placeholder="Enter name" class="form-control" aria-label="State"
                                        [formControl]="testerCtrl" [matAutocomplete]="autoUser" />
                                    <mat-autocomplete #autoUser="matAutocomplete" (optionSelected)="selectedTester($event)" [displayWith]="displayProperty">
                                        <mat-option *ngFor="let state of filteredUsers | async" [value]="state">
                                            <span>{{state.displayName }} - {{state.jobTitle}}</span>
                                        </mat-option>
                                    </mat-autocomplete>
                                </div>
                            </div>

                            <div class="slip-label required">Associated with SFI testing</div>
                            <div class="slip-detail-value">
                                <select name="SFI" class="form-control" formControlName="isSFI">
                                    <option value="" disabled selected hidden>Select</option>
                                    <option *ngFor="let option of sfiOption" [value]="option.id">
                                        {{ option.value }}
                                    </option>
                                </select>
                            </div>

                            <div class="slip-label">Relevant Notes</div>
                            <div class="slip-detail-value">
                                <input type="text" formControlName="comments" class="form-control input-sm txt-input"
                                    placeholder="Enter notes">
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>

                <div class="p-3" id="testPlanCommenttab">
                    <mat-expansion-panel (opened)="panelOpenState = true" (closed)="panelOpenState = false"
                        [expanded]="true">
                        <mat-expansion-panel-header>
                            <mat-panel-title class="headertesttext">
                                Comments
                            </mat-panel-title>
                        </mat-expansion-panel-header>

                        <div class="files-list-container" *ngIf="files.length != 0">
                            <div class="files-list" *ngFor="let file of files;let i= index">
                                {{ file.name }}
                                <button class="delete-file" (click)="deleteAttachment(i)">
                                    <img src="./assets/images/Delete.png">
                                </button>
                            </div>
                        </div>
                        <div class="add-comment" id="addComments">
                            <div>Add Comment</div>
                            <div>
                                <textarea class="comment-textarea" rows="4" cols="71" name="comment"
                                    [(ngModel)]="comments"></textarea>
                            </div>
                            <div class="comment-btn">
                                <button type="button" (click)="submitTestSlip()" class="btn btn-add-comment"
                                    [disabled]="testslipDetailsForm.invalid">
                                    Submit paper slip
                                </button>
                                <div class="uploadfilecontainer">
                                    <input hidden type="file" multiple #fileInput (change)="uploadFile($event.target)">
                                    <div class="innter-container">
                                        <button type="button" (click)="fileInput.click()"
                                            class="btn btn-upload-document">
                                            Attach Document
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </mat-expansion-panel>
                </div>
            </div>
        </div>
    </div>
</div>